module.exports = __webpack_public_path__ + "static/img/floorList.59e1bf59.png";